export enum PROFILE_UPLOAD_FILE_STATUS {
    PRIMARY = 1
}

export enum FILE_UPLOAD_SOURCE {
    PROFILE = 1
}